import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React from 'react';
import { Card, Col, Dropdown, Image, Row, Button, Modal, Form } from 'react-bootstrap';
import DiscreteReferenceChecks from '../../clients/candidate-information/candidate-sub-content-pane/discreteReferenceChecks.js';
import {
    faBagShopping,
    faBriefcase,
    faBuilding,
    faCalendarAlt,
    faCar,
    faChevronDown, faChevronUp,
    faDownload,
    faIndustry,
    faMapMarkerAlt,
    faPen,
    faPlayCircle
} from '@fortawesome/free-solid-svg-icons';
import { MasterDataService } from '../../../services/masterDataService.js';
import { useEffect, useState, useRef } from 'react';
import { CandidateService, decodeJWT } from '../../../services/candidateService.js';
import axios from 'axios';
import { serverConfig } from '../../../services/server-config.js';
import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import CandidateProfileNav from '../candidateProfileNav/candidateProfileNav.js';
import CandidateProfileContentPane from '../candidateProfileSubContentPane/candidateProfileContentPane/candidateProfileContentPane.js';

import { useNavigate } from 'react-router-dom';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService.js';
import CandidateProfessionalMembershipContent from '../candidateProfileSubContentPane/candidateProfessionalMembership.js';
import { useCandidateUser } from '../candidateUserContext/candidateUserContext.js';
import { Spinner } from 'react-bootstrap';
import CloseIcon from '../../../assets/images/Ic_close.png';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
export const ProfileLeftContent = ({ candidateData, setCandidateData, fetchCandidateData, refreshPage, candidateStatus }) => {
    const inputResumeRef = useRef(null);
    const navigate = useNavigate();
    const [uploading, setUploading] = useState(false);
    const { candidate, setCandidate } = useCandidateUser();
    const decoded = decodeJWT(window.localStorage.getItem('authToken'));
    const candidateId = _.get(decoded, 'username', '');
    const inputFileRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [imageUrl, setImageUrl] = useState(default_profile_image);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [attemptedLeave, setAttemptedLeave] = useState(false);

    // const [currentPinCode, setCurrentPinCode] = useState(_.get(candidateData, 'workExperience.currentRole.pinCode') || '');
    // const [tempPinCode, setTempPinCode] = useState(currentPinCode);
    // const [pinCodeError, setPinCodeError] = useState('');
    const [cityOptions, setCityOptions] = useState([]);

    const [showModal, setShowModal] = useState(false);

    // Work Experience fields
    const [designation, setDesignation] = useState(_.get(candidateData, 'workExperience.currentRole.designation') || '');
    const [tempDesignation, setTempDesignation] = useState(designation);

    const [orgName, setOrgName] = useState(_.get(candidateData, 'workExperience.currentRole.orgName') || '');
    const [tempOrgName, setTempOrgName] = useState(orgName);

    const [location, setLocation] = useState(_.get(candidateData, 'workExperience.currentRole.location') || '');
    const [tempLocation, setTempLocation] = useState(location);

    const [industry, setIndustry] = useState(_.get(candidateData, 'workExperience.currentRole.industry') || '');
    const [tempIndustry, setTempIndustry] = useState(industry);

    const [jobFunction, setJobFunction] = useState(_.get(candidateData, 'workExperience.currentRole.function') || '');
    const [tempJobFunction, setTempJobFunction] = useState(jobFunction);

    const [functionSubcategory, setFunctionSubcategory] = useState(_.get(candidateData, 'workExperience.currentRole.functionSubcategory') || '');
    const [tempFunctionSubcategory, setTempFunctionSubcategory] = useState(functionSubcategory);
    // Industry Subcategory
    const [industrySubcategory, setIndustrySubcategory] = useState(_.get(candidateData, 'workExperience.currentRole.industrySubcategory') || '');
    const [tempIndustrySubcategory, setTempIndustrySubcategory] = useState(industrySubcategory);

    // Master data options
    const [sectorList, setSectorList] = useState([]);
    const [subSectorList, setSubSectorList] = useState([]);

    // Function master data
    const [functionList, setFunctionList] = useState([]);
    const [functionSubcategoryList, setFunctionSubcategoryList] = useState([]);

    // Value Adds fields
    const [locationPref1, setLocationPref1] = useState(_.get(candidateData, 'valueAdds.locationPref1') || '');
    const [tempLocationPref1, setTempLocationPref1] = useState(locationPref1);

    const [locationPref2, setLocationPref2] = useState(_.get(candidateData, 'valueAdds.locationPref2') || '');
    const [tempLocationPref2, setTempLocationPref2] = useState(locationPref2);

    const [locationPref3, setLocationPref3] = useState(_.get(candidateData, 'valueAdds.locationPref3') || '');
    const [tempLocationPref3, setTempLocationPref3] = useState(locationPref3);

    const [jobTypes, setJobTypes] = useState(_.get(candidateData, 'valueAdds.jobTypes') || []);
    const [tempJobTypes, setTempJobTypes] = useState(jobTypes);

    const [willingToRelocate, setWillingToRelocate] = useState(_.get(candidateData, 'valueAdds.willingToRelocate') || '');
    const [tempWillingToRelocate, setTempWillingToRelocate] = useState(willingToRelocate);

    const [willingToTravelToWork, setWillingToTravelToWork] = useState(_.get(candidateData, 'valueAdds.willingToTravelToWork') || '');
    const [tempWillingToTravelToWork, setTempWillingToTravelToWork] = useState(willingToTravelToWork);

    const [willingToWorkSixDayWeeks, setWillingToWorkSixDayWeeks] = useState(_.get(candidateData, 'valueAdds.willingToWorkSixDayWeeks') || '');
    const [tempWillingToWorkSixDayWeeks, setTempWillingToWorkSixDayWeeks] = useState(willingToWorkSixDayWeeks);

    // Expertise and Achievements fields
    const [expertiseText, setExpertiseText] = useState(_.get(candidateData, 'workExperience.currentRole.topThreeResponsibilities') || '');
    const [tempExpertiseText, setTempExpertiseText] = useState(expertiseText);

    const [achievementsText, setAchievementsText] = useState(_.get(candidateData, 'workExperience.currentRole.topThreeAchievements') || '');
    const [tempAchievementsText, setTempAchievementsText] = useState(achievementsText);
    const [professionalMemberships, setProfessionalMemberships] = useState(
        _.get(candidateData, 'workExperience.professionalMemberships', [])
    );

    const [professionalReferences, setProfessionalReferences] = useState(
        _.get(candidateData, 'valueAdds.professionalReferences', [])
    );

    const [fieldErrors, setFieldErrors] = useState({});
    const countWords = (text) => text.trim().split(/\s+/).filter(Boolean).length;



    const handleDesignationChange = (e) => {
        const value = e.target.value;
        setTempDesignation(value);
        if (value.trim().length > 0 && (value.trim().length < 2 || value.trim().length > 100)) {
            setFieldErrors(prev => ({ ...prev, designation: 'Designation must be 2–100 characters' }));
        } else {
            setFieldErrors(prev => ({ ...prev, designation: '' }));
        }
    };

    const handleOrgNameChange = (e) => {
        const value = e.target.value;
        setTempOrgName(value);
        if (value.trim().length > 0 && (value.trim().length < 2 || value.trim().length > 100)) {
            setFieldErrors(prev => ({ ...prev, orgName: 'Organization Name must be 2–100 characters' }));
        } else {
            setFieldErrors(prev => ({ ...prev, orgName: '' }));
        }
    };

    const handleIndustryChange = (e) => {
        const value = e.target.value;
        setTempIndustry(value);
        if (value.trim().length > 0 && (value.trim().length < 2 || value.trim().length > 100)) {
            setFieldErrors(prev => ({ ...prev, industry: 'Industry must be 2–100 characters' }));
        } else {
            setFieldErrors(prev => ({ ...prev, industry: '' }));
        }
        setTempIndustrySubcategory('');
    };
    const handleFunctionChange = (e) => {
        const value = e.target.value;
        setTempJobFunction(value);
        if (value.trim().length > 0 && (value.trim().length < 2 || value.trim().length > 100)) {
            setFieldErrors(prev => ({ ...prev, function: 'Industry must be 2–100 characters' }));
        } else {
            setFieldErrors(prev => ({ ...prev, function: '' }));
        }
        setTempFunctionSubcategory('');
    };

    const handleExpertiseChange = (e) => {
        const value = e.target.value;
        const words = countWords(value);
        if (words <= 250) {
            setTempExpertiseText(value);
            setFieldErrors(prev => ({ ...prev, expertise: '' }));
        } else {
            setFieldErrors(prev => ({ ...prev, expertise: 'Maximum 250 words allowed' }));
        }
    };

    const handleAchievementsChange = (e) => {
        const value = e.target.value;
        const words = countWords(value);
        if (words <= 250) {
            setTempAchievementsText(value);
            setFieldErrors(prev => ({ ...prev, achievements: '' }));
        } else {
            setFieldErrors(prev => ({ ...prev, achievements: 'Maximum 250 words allowed' }));
        }
    };

    useEffect(() => {
        MasterDataService.getAllCities()
            .then((res) => {
                setCityOptions(res.data);
            })
            .catch((err) => {
                console.error('Failed to fetch cities:', err);
            });
    }, []);

    useEffect(() => {
        let mounted = true;
        const loadSectors = async () => {
            try {
                const res = await MasterDataService.getAllIndustrySectors();
                const arr = _.get(res, 'data', res);
                if (Array.isArray(arr)) {
                    if (mounted) setSectorList(arr);
                } else if (Array.isArray(_.get(res, 'data.data'))) {
                    if (mounted) setSectorList(_.get(res, 'data.data'));
                } else {
                    if (mounted) setSectorList([]);
                }
            } catch (err) {
                console.error('Failed to fetch industry sectors', err);
                if (mounted) setSectorList([]);
            }
        };
        loadSectors();
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        let mounted = true;

        const loadSubSectors = async () => {
            if (!tempIndustry || !sectorList.length) {
                if (mounted) {
                    setSubSectorList([]);
                    setTempIndustrySubcategory('');
                }
                return;
            }

            const sectorObj = sectorList.find(s =>
                s?.id &&
                (
                    s.industrySector === tempIndustry ||
                    s.name === tempIndustry ||
                    s.sector === tempIndustry
                )
            );

            if (!sectorObj?.id) {
                if (mounted) setSubSectorList([]);
                return;
            }

            try {
                const res = await MasterDataService.getIndustrySubcategories(sectorObj.id);
                const subs = _.get(res, 'data', []);
                if (mounted) setSubSectorList(Array.isArray(subs) ? subs : []);
            } catch (err) {
                console.error('Failed to fetch industry subcategories', err);
                if (mounted) setSubSectorList([]);
            }
        };

        loadSubSectors();
        return () => { mounted = false; };
    }, [tempIndustry, sectorList]);

    useEffect(() => {
        let mounted = true;

        const loadFunctions = async () => {
            try {
                const res = await MasterDataService.getAllFunctions();
                const list = _.get(res, 'data', []);
                if (mounted) setFunctionList(Array.isArray(list) ? list : []);
            } catch (err) {
                console.error('Failed to fetch functions', err);
                if (mounted) setFunctionList([]);
            }
        };

        loadFunctions();
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        let mounted = true;

        const loadFunctionSubcategories = async () => {
            if (!tempJobFunction || !functionList.length) {
                if (mounted) {
                    setFunctionSubcategoryList([]);
                }
                return;
            }

            const functionObj = functionList.find(f =>
                f?.id &&
                (
                    f.function === tempJobFunction ||
                    f.name === tempJobFunction
                )
            );

            if (!functionObj?.id) {
                if (mounted) setFunctionSubcategoryList([]);
                return;
            }

            try {
                const res = await MasterDataService.getFunctionSubcategories(functionObj.id);
                const subs = _.get(res, 'data', []);
                if (mounted) setFunctionSubcategoryList(Array.isArray(subs) ? subs : []);
            } catch (err) {
                console.error('Failed to fetch function subcategories', err);
                if (mounted) setFunctionSubcategoryList([]);
            }
        };

        loadFunctionSubcategories();
        return () => { mounted = false; };
    }, [tempJobFunction, functionList]);

    const openModal = () => {
        setTempDesignation(designation);
        setTempOrgName(orgName);
        setTempIndustry(industry);
        setTempLocation(location);
        setTempLocationPref1(locationPref1);
        setTempLocationPref2(locationPref2);
        setTempLocationPref3(locationPref3);
        setTempJobTypes(jobTypes);
        setTempWillingToRelocate(willingToRelocate);
        setTempWillingToTravelToWork(willingToTravelToWork);
        setTempWillingToWorkSixDayWeeks(willingToWorkSixDayWeeks);
        setTempExpertiseText(expertiseText);
        setTempAchievementsText(achievementsText);
        setTempIndustrySubcategory(industrySubcategory);
        setFieldErrors({});
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleJobTypeChange = (type) => {
        if (tempJobTypes.includes(type)) {
            setTempJobTypes(tempJobTypes.filter(j => j !== type));
        } else {
            setTempJobTypes([...tempJobTypes, type]);
        }
    };
    const saveChanges = async () => {
        const hasLiveErrors = Object.values(fieldErrors).some((err) => err && err.trim() !== '');
        if (hasLiveErrors) {
            setErrorMessage("Please fix the field-level validation errors before saving.");
            return;
        }
        const missingFields = [];

        if (!tempDesignation) missingFields.push("Designation");
        if (!tempOrgName) missingFields.push("Organization Name");
        if (!tempIndustry) missingFields.push("Industry");
        if (!tempJobTypes || tempJobTypes.length === 0) missingFields.push("Work Preferences");
        if (!tempWillingToRelocate) missingFields.push("Willing to Relocate");
        if (!tempWillingToTravelToWork) missingFields.push("Travel for Work");
        if (!tempWillingToWorkSixDayWeeks) missingFields.push("Weekly Working Days");

        if (missingFields.length > 0) {
            setErrorMessage(`Please fill all required field(s):\n- ${missingFields.join("\n- ")}`);
            return;
        }
        try {
            setLoading(true);
            const payload = {
                designation: tempDesignation,
                industry: tempIndustry,
                industrySubcategory: tempIndustrySubcategory,
                function: tempJobFunction,
                functionSubcategory: tempFunctionSubcategory,
                currentJobLocation: tempLocation,
                currentJobCompany: tempOrgName,
                locationPref1: tempLocationPref1,
                locationPref2: tempLocationPref2,
                locationPref3: tempLocationPref3,
                jobTypes: tempJobTypes,
                willingToRelocate: tempWillingToRelocate,
                willingToTravelToWork: tempWillingToTravelToWork,
                willingToWorkSixDayWeeks: tempWillingToWorkSixDayWeeks,
                expertise: tempExpertiseText,
                achievements: tempAchievementsText,
            };

            await CandidatePostLoginService.submitPanelByType('TOP_LEFT_PANEL', payload);


            const updatedData = {
                ...candidateData,
                workExperience: {
                    ...(candidateData?.workExperience || {}),
                    currentRole: {
                        ...(candidateData?.workExperience?.currentRole || {}),
                        designation: tempDesignation,
                        industry: tempIndustry,
                        industrySubcategory: tempIndustrySubcategory, // added
                        function: tempJobFunction,
                        functionSubcategory: tempFunctionSubcategory,
                        orgName: tempOrgName,
                        location: tempLocation,
                        topThreeResponsibilities: tempExpertiseText,
                        topThreeAchievements: tempAchievementsText,
                    },
                },
                valueAdds: {
                    ...(candidateData?.valueAdds || {}),
                    locationPref1: tempLocationPref1,
                    locationPref2: tempLocationPref2,
                    locationPref3: tempLocationPref3,
                    jobTypes: tempJobTypes,
                    willingToRelocate: tempWillingToRelocate,
                    willingToTravelToWork: tempWillingToTravelToWork,
                    willingToWorkSixDayWeeks: tempWillingToWorkSixDayWeeks,
                },
            };

            setCandidateData(updatedData);
            setDesignation(tempDesignation);
            setOrgName(tempOrgName);
            setLocation(tempLocation);
            setIndustry(tempIndustry);
            setIndustrySubcategory(tempIndustrySubcategory);
            setJobFunction(tempJobFunction);
            setFunctionSubcategory(tempFunctionSubcategory);
            setLocationPref1(tempLocationPref1);
            setLocationPref2(tempLocationPref2);
            setLocationPref3(tempLocationPref3);
            setJobTypes(tempJobTypes);
            setWillingToRelocate(tempWillingToRelocate);
            setWillingToTravelToWork(tempWillingToTravelToWork);
            setWillingToWorkSixDayWeeks(tempWillingToWorkSixDayWeeks);

            setExpertiseText(tempExpertiseText);
            setAchievementsText(tempAchievementsText);
            refreshPage();
            closeModal();
        } catch (err) {
            setErrorMessage('Save failed');
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    };



    const handleResumeUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);


        CandidateService.uploadFile(
            formData,
            'RESUME',
            (res) => {
                setUploading(false);
                setErrorMessage('Resume uploaded successfully');
            },
            (val) => {
                setUploading(val);
            }
        );
    };

    const downloadFile = (resumePath, fileName) => {
        CandidateService.downloadResume(encodeURI(resumePath))
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => console.error(err));
    };

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [childCandidateNavigation, setChildCandidateNavigation] = useState('experience');
    useEffect(() => {
        const collapsibleContent = document.querySelector('.collapsible-content');
        const lineHeight = parseInt(window.getComputedStyle(collapsibleContent).lineHeight);
        const maxLines = 5;
        const maxHeight = lineHeight * maxLines;

        if (collapsibleContent.clientHeight > maxHeight) {
            setIsCollapsed(true);
        }
    }, []);
    const toggleContent = () => {
        setIsCollapsed(!isCollapsed);
    };


    const displayPicPath = candidateData?.personalDetails?.displayPic?.[0]?.path;

    useEffect(() => {
        if (!displayPicPath) return;

        const fetchImage = async () => {
            try {
                const response = await axios.get(
                    `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${displayPicPath}`,
                    {
                        headers: CandidateService.getAuthHeader(),
                        responseType: "blob",
                    }
                );
                const blob = new Blob([response.data], {
                    type: response.headers["content-type"],
                });
                const url = URL.createObjectURL(blob);
                setImageUrl(url);
            } catch (error) {
                console.error("Error fetching image:", error);
            }
        };

        fetchImage();
    }, [displayPicPath]);

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const ext = file.name.split(".").pop().toLowerCase();
        if (!["jpg", "jpeg", "png", "gif"].includes(ext)) {
            alert("Only jpg, jpeg, png, and gif files are allowed!");
            return;
        }

        if (file.size > 1048576) {
            alert("File size exceeded the 1MB limit");
            return;
        }

        const tempBlobUrl = URL.createObjectURL(file);
        setCandidate((prev) => ({
            ...prev,
            imageBlobUrl: tempBlobUrl,
        }));

        setUploading(true);

        const formData = new FormData();
        formData.append("file", file);

        CandidatePostLoginService.uploadCandidateFile(
            formData,
            "CANDIDATE_DP",
            async (res) => {
                try {
                    if (res?.data?.filePath) {
                        const filePath = res.data.filePath;

                        setCandidateData((prev) => ({
                            ...prev,
                            personalDetails: {
                                ...prev.personalDetails,
                                displayPic: [{ path: filePath }],
                            },
                        }));

                        const response = await axios.get(
                            `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${filePath}`,
                            {
                                headers: CandidateService.getAuthHeader(),
                                responseType: "blob",
                            }
                        );

                        const blob = new Blob([response.data], {
                            type: response.headers["content-type"],
                        });
                        const blobUrl = URL.createObjectURL(blob);

                        setCandidate((prev) => ({
                            ...prev,
                            dpPath: filePath,
                            imageBlobUrl: blobUrl,
                        }));
                    }
                } catch (err) {
                    console.error("Upload image error:", err);
                } finally {
                    setUploading(false);
                }
            },
            () => {
                setUploading(false);
            }
        );
    };

    useEffect(() => {
        if (attemptedLeave) {
            const timeout = setTimeout(() => {
                setShowConfirmModal(true);
                setAttemptedLeave(false);
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [attemptedLeave]);


    // const handleSubmitForApproval = async () => {
    //     try {
    //         await CandidatePostLoginService.submitForApproval();

    //         setIsSubmitted(true);
    //         setShowConfirmModal(false);
    //         setShowSuccessModal(true);

    //         if (typeof fetchCandidateData === "function") {
    //             await fetchCandidateData();
    //         }
    //     } catch (err) {
    //         console.error("Submit for approval failed", err);
    //         const errorMessage = err?.response?.data?.message || "Something went wrong.";
    //         setErrorMessage(errorMessage);
    //     }
    // };

    const handleSubmitForApproval = async () => {
        try {
            await CandidatePostLoginService.submitForApproval();

            // Submission API succeeded
            setIsSubmitted(true);
            setShowConfirmModal(false);
            setShowSuccessModal(true);

            // Refresh data separately
            if (typeof fetchCandidateData === "function") {
                try {
                    await fetchCandidateData();
                } catch (fetchError) {
                    console.error("Failed to refresh candidate data:", fetchError);
                }
            }
        } catch (err) {
            console.error("Submit for approval failed", err);

            const errorMessage =
                err?.response?.data?.message ||
                "Something went wrong while submitting your profile.";

            setErrorMessage(errorMessage);
        }
    };


    const psychometricDashboardClick = () => {
        navigate('/candidate/psychometric-test/dashboard')
    };


    return (
        <Col className="pb-3">
            <Card>
                <Card.Body className="candidateInformation">
                    {errorMessage && (
                        <div className="custom-alert-overlay">
                            <div className="custom-alert-box">
                                <div className="custom-alert-content">
                                    <p>{errorMessage}</p>
                                    <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                        <Modal.Body className="profileleft-modal-body">
                            <p>Please ensure that all information is accurate, then click below to submit your profile for approval.</p>
                            <div className="profileleft-modal-footer">
                                <button
                                    className="profileleft-modal-button profileleft-cancel-button"
                                    onClick={() => setShowConfirmModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="profileleft-modal-button profileleft-submit-button"
                                    onClick={handleSubmitForApproval}
                                >
                                    Submit
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                        <Modal.Body className="profileleft-modal-body">
                            <p>
                                Thanks for submitting your profile!
                                <br />
                                As a new member, you’re invited to take our flagship psychometric assessment at 50% off — for a limited time.
                            </p>

                            <ul style={{ listStyle: "none" }}>
                                <li>✅ Discover your unique leadership style</li>
                                <li>✅ Get a personalized report with actionable insights</li>
                                <li>✅ Stand out to top hiring companies</li>
                            </ul>

                            <p>Limited-time offer. Don’t miss out.</p>

                            <div className="profileleft-modal-footer">
                                <Button className="approve-button" onClick={psychometricDashboardClick}>
                                    Take Test Now
                                </Button>{' '}
                                <button
                                    className="profileleft-modal-button profileleft-submit-button"
                                    onClick={() => setShowSuccessModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>


                    <Row className="d-none d-md-flex">
                        <Col md={2} className="d-flex justify-content-center align-items-center">
                            <div
                                className="rounded-circle overflow-hidden position-relative profile-pic-container mt-2"
                                onClick={() => inputFileRef.current?.click()}
                                style={{ cursor: 'pointer' }}
                            >

                                <Image
                                    src={candidate?.imageBlobUrl || default_profile_image}
                                    width={120}
                                    height={120}
                                    alt="Profile Image"
                                    aspectRatio="16x9"
                                />

                                {' '}
                                {uploading && (
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                        style={{ backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 10 }}
                                    >
                                        <Spinner animation="border" />
                                    </div>
                                )}
                                <div className="overlay">
                                    <FontAwesomeIcon icon={faPen} color="#F35824" />
                                    <span className="ms-1">Edit Image</span>
                                </div>

                                <input
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.gif"
                                    ref={inputFileRef}
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </Col>
                        <Col md={6} className="d-flex justify-content-left align-items-center">
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h2 className="candidateTitle mb-0">
                                            {_.get(candidateData, 'personalDetails.firstName')}{' '}
                                            {_.get(candidateData, 'personalDetails.lastName')} | {candidateId}
                                            <FontAwesomeIcon icon={faPen} size='sm' onClick={openModal} className="ms-3" style={{ color: '#f35824', fontSize: '14px', cursor: 'pointer' }} />
                                        </h2>
                                    </div>
                                </Col>

                                <Col md={12}>

                                    <h3 className="candidateSubTitle">

                                        <>
                                            {designation}{' '}
                                            <span className="candidateSubTitleStyle2">
                                                {designation ? ' at ' : ''}
                                                {orgName}, {location}
                                            </span>

                                            <br />

                                        </>
                                        <>
                                            <h3 className="candidateSubTitle candidateSubTitleStyle2" style={{ marginTop: '10px' }}>
                                                <FontAwesomeIcon className="preference-icon" icon={faIndustry} /> {industry} - {industrySubcategory}
                                                {' | '}
                                                <FontAwesomeIcon className="preference-icon" icon={faBuilding} /> {jobFunction} - {functionSubcategory}
                                            </h3>
                                        </>
                                    </h3>
                                </Col>

                            </Row>
                        </Col>
                        <Col md={4} className='download-resume-section '>
                            <Row>
                                <Col md={12} className="d-md-flex justify-content-end">
                                    <a
                                        href="#"
                                        className="resetLinkStyle candidateCVDownload"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            const resumePath = _.get(candidateData, 'personalDetails.resume[0].path', null);
                                            const resumeName = _.get(candidateData, 'personalDetails.resume[0].displayFileName', null);

                                            if (!resumePath || !resumeName) {
                                                setErrorMessage('Resume not available');
                                            } else {
                                                downloadFile(resumePath, resumeName);
                                            }
                                        }}
                                    >
                                        Download CV <FontAwesomeIcon icon={faDownload} />
                                    </a>
                                    &nbsp;&nbsp;
                                    <div>
                                        {/* <FontAwesomeIcon icon={faPen} size='sm'
                                            style={{ color: '#F35824', cursor: 'pointer' }}
                                            onClick={() => inputResumeRef.current.click()}
                                            disabled={uploading}
                                        /> */}

                                        <input
                                            type="file"
                                            ref={inputResumeRef}
                                            style={{ display: 'none' }}
                                            onChange={handleResumeUpload}
                                            accept=".pdf,.doc,.docx"
                                        />
                                    </div>

                                    {errorMessage && (
                                        <div className="text-danger mt-1">
                                            {errorMessage}
                                        </div>
                                    )}

                                    {/* <span style={{ paddingLeft: 5, paddingRight: 5 }}>{' | '}</span>
                                    <a href="#" className="resetLinkStyle metVidStyle">
                                        <span>Met Vid Video </span>
                                        <FontAwesomeIcon className="orangeColor" icon={faPlayCircle}></FontAwesomeIcon>
                                    </a> */}
                                </Col>

                                <Col md={12} className="d-md-flex justify-content-end rework-approve-buttons">
                                    <Button className="approve-button" onClick={() => setShowConfirmModal(true)}>
                                        Submit
                                    </Button>

                                    <Button className="approve-button" onClick={psychometricDashboardClick}>
                                        Take DISC Test
                                    </Button>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                    <Row className="d-none d-md-flex">
                        {/* Location Preference */}
                        <Col md={12} className="d-md-flex justify-content-left pt-3">

                            <>
                                <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                    <FontAwesomeIcon className="preference-icon" icon={faMapMarkerAlt} /> Location Preference: {' '}
                                    {[locationPref1 && `${locationPref1} `, locationPref2 && `${locationPref2}`, locationPref3 && `${locationPref3}`]
                                        .filter(Boolean)
                                        .join(' | ')}
                                </h3>

                            </>

                        </Col>

                        {/* Work Preference */}
                        <Col md={12} className="d-md-flex justify-content-left pt-2">


                            <>
                                <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                    <FontAwesomeIcon className="preference-icon" icon={faBriefcase} /> Work Preference: {' '}
                                    {jobTypes.join(' | ')}
                                </h3>

                            </>

                        </Col>

                        {/* Other Preferences */}
                        <Col md={12} className="d-md-flex justify-content-left pt-2">

                            <>
                                <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                    <span className="col-sm-4 d-block d-md-inline">
                                        <FontAwesomeIcon className="preference-icon" icon={faCar} /> Willing to Relocate: {willingToRelocate}
                                    </span>
                                    <span className="ps-md-2 col-sm-4 d-block d-md-inline">
                                        <FontAwesomeIcon className="preference-icon" icon={faBagShopping} /> Willing To Travel For Work: {willingToTravelToWork}
                                    </span>
                                    <span className="ps-md-2 col-sm-4 d-block d-md-inline">
                                        <FontAwesomeIcon className="preference-icon" icon={faCalendarAlt} />  Preferred Number of Working Days: {willingToWorkSixDayWeeks === 'YES' ? 'Six Days' : 'Five Days'}
                                    </span>
                                </h3>

                            </>
                        </Col>
                    </Row>

                    <Row className="d-none d-md-flex">
                        <Col md={12} className="ps-4">
                            <div id="collapsibleSection">
                                <div className={`collapsible-content ${isCollapsed ? 'collapsed' : ''}`}>

                                    {/* Expertise Section */}
                                    <div className="d-flex align-items-center">
                                        <h2 className="candidateDisplaySectionHeadingStyle1 mb-0">Expertise</h2> &nbsp;
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your core skills, knowledge areas, and industry experience.
                                            </div>
                                        </div>

                                    </div>

                                    <div className="candidateDisplaySectionContentStyle1 pt-2">

                                        <>
                                            {(_.get(candidateData, 'workExperience.currentRole.topThreeResponsibilities') || '')
                                                .split('\n')
                                                .filter((line) => line.trim() !== '')
                                                .map((text, index) => (
                                                    <p key={index}>{text}</p>
                                                ))}
                                        </>
                                    </div>

                                    {/* Achievements Section */}
                                    <div className="d-flex align-items-center mt-4">
                                        <h2 className="candidateDisplaySectionHeadingStyle1 mb-0">Achievements</h2> &nbsp;
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your major accomplishments and career highlights.
                                            </div>
                                        </div>

                                    </div>

                                    <div className="candidateDisplaySectionContentStyle1 pt-2">

                                        <>
                                            {(_.get(candidateData, 'workExperience.currentRole.topThreeAchievements') || '')
                                                .split('\n')
                                                .filter((line) => line.trim() !== '')
                                                .map((text, index) => (
                                                    <p key={index}>{text}</p>
                                                ))}
                                        </>
                                    </div>

                                </div>
                            </div>
                        </Col>


                    </Row>
                    <Row className="d-none d-md-flex">
                        <Col className="d-flex justify-content-center candidateCVDownload">
                            <a id="toggleButton" onClick={toggleContent}>
                                {isCollapsed ? 'View More' : 'View Less'}{' '}
                                <span>
                                    <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
                                </span>
                            </a>
                        </Col>
                    </Row>

                    <Modal show={showModal} onHide={closeModal} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
                        <Modal.Header className="d-flex justify-content-between align-items-center">
                            <Modal.Title>Edit Current Work Profile</Modal.Title>
                            <img
                                src={CloseIcon}
                                alt="Close"
                                onClick={closeModal}
                                style={{
                                    cursor: 'pointer',
                                    width: '24px',
                                    height: '24px',
                                }}
                            />
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                {/* Work Experience Form Fields */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Designation<span style={{ color: 'red' }}> *</span></Form.Label>
                                    <Form.Control
                                        value={tempDesignation}
                                        onChange={handleDesignationChange}
                                        isInvalid={!!fieldErrors.designation}
                                        spellCheck='false'
                                        style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.designation}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Organization Name<span style={{ color: 'red' }}> *</span></Form.Label>
                                    <Form.Control
                                        value={tempOrgName}
                                        onChange={handleOrgNameChange}
                                        isInvalid={!!fieldErrors.orgName}
                                        spellCheck='false'
                                        style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.orgName}
                                    </Form.Control.Feedback>
                                </Form.Group>


                                <Form.Group className="mb-3">
                                    <Form.Label>Work Location</Form.Label>
                                    <Form.Select style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                        value={tempLocation}
                                        onChange={(e) => setTempLocation(e.target.value)}
                                    >
                                        <option value="" >Select a city</option>
                                        {cityOptions.map((city) => (
                                            <option key={city} value={city}>
                                                {city}
                                            </option>
                                        ))}

                                    </Form.Select>
                                </Form.Group>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Industry Sector <span style={{ color: 'red' }}> *</span></Form.Label>
                                            <Form.Select
                                                value={tempIndustry || ''}
                                                onChange={(e) => {
                                                    handleIndustryChange(e);
                                                }}
                                                isInvalid={!!fieldErrors.industry}
                                                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            >
                                                <option value="">-- Select Industry --</option>
                                                {sectorList.map((s) => {
                                                    if (!s) return null;
                                                    if (typeof s === 'string') {
                                                        return <option key={s} value={s}>{s}</option>;
                                                    }
                                                    const label = s.industrySector || s.name || s.sector || JSON.stringify(s);
                                                    return <option key={s.id || label} value={label}>{label}</option>;
                                                })}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{fieldErrors.industry}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Industry Subcategory</Form.Label>
                                            <Form.Select
                                                value={tempIndustrySubcategory || ''}
                                                onChange={(e) => setTempIndustrySubcategory(e.target.value)}
                                                disabled={!tempIndustry || subSectorList.length === 0}
                                                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            >
                                                <option value="">-- Select Subcategory --</option>
                                                {subSectorList.map((sub) => {
                                                    if (!sub) return null;
                                                    if (typeof sub === 'string') {
                                                        return <option key={sub} value={sub}>{sub}</option>;
                                                    }
                                                    const label = sub.subcategory || sub.name || JSON.stringify(sub);
                                                    return <option key={sub.id || label} value={label}>{label}</option>;
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Function</Form.Label>
                                            <Form.Select
                                                value={tempJobFunction || ''}
                                                onChange={(e) => {
                                                    handleFunctionChange(e);
                                                }}
                                                isInvalid={!!fieldErrors.function}
                                                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            >
                                                <option value="">-- Select Function --</option>
                                                {functionList.map((f) => {
                                                    if (!f) return null;

                                                    if (typeof f === 'string') {
                                                        return (
                                                            <option key={f} value={f}>
                                                                {f}
                                                            </option>
                                                        );
                                                    }

                                                    const label = f.function || f.name;
                                                    return (
                                                        <option key={f.id || label} value={label}>
                                                            {label}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{fieldErrors.function}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Function Subcategory</Form.Label>
                                            <Form.Select
                                                value={tempFunctionSubcategory || ''}
                                                onChange={(e) => setTempFunctionSubcategory(e.target.value)}
                                                disabled={!tempJobFunction || functionSubcategoryList.length === 0}
                                                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            >
                                                <option value="">-- Select Subcategory --</option>
                                                {functionSubcategoryList.map((sub) => {
                                                    if (!sub) return null;

                                                    if (typeof sub === 'string') {
                                                        return (
                                                            <option key={sub} value={sub}>
                                                                {sub}
                                                            </option>
                                                        );
                                                    }

                                                    const label = sub.subcategory || sub.name;
                                                    return (
                                                        <option key={sub.id || label} value={label}>
                                                            {label}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">

                                    <Col>
                                        <Form.Label>Location Preferences</Form.Label>

                                        <Form.Select style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            className="mb-2"
                                            value={tempLocationPref1}
                                            onChange={(e) => setTempLocationPref1(e.target.value)}
                                        >
                                            <option value="">1st Preference</option>
                                            {cityOptions.map((city) => (
                                                <option key={city} value={city}>{city}</option>
                                            ))}
                                        </Form.Select>

                                        <Form.Select style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            className="mb-2"
                                            value={tempLocationPref2}
                                            onChange={(e) => setTempLocationPref2(e.target.value)}
                                        >
                                            <option value="">2nd Preference</option>
                                            {cityOptions.map((city) => (
                                                <option key={city} value={city}>{city}</option>
                                            ))}
                                        </Form.Select>

                                        <Form.Select style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                            value={tempLocationPref3}
                                            onChange={(e) => setTempLocationPref3(e.target.value)}
                                        >
                                            <option value="">3rd Preference</option>
                                            {cityOptions.map((city) => (
                                                <option key={city} value={city}>{city}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>


                                <Row className="mb-3">
                                    <Col>
                                        <Form.Label> Work Preferences<span style={{ color: 'red' }}> *</span></Form.Label><br />
                                        {['HYBRID', 'REMOTE', 'ON_SITE'].map((type) => (
                                            <Form.Check
                                                key={type}
                                                inline
                                                label={type.replace('_', ' ').toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())}
                                                checked={tempJobTypes.includes(type)}
                                                onChange={() => handleJobTypeChange(type)}
                                                type="checkbox"
                                            />
                                        ))}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col>
                                        <Form.Label> Willing to Relocate<span style={{ color: 'red' }}> *</span></Form.Label><br />
                                        {['YES', 'NO'].map((val) => (
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label={val}
                                                name="relocate"
                                                key={val}
                                                checked={tempWillingToRelocate === val}
                                                onChange={() => setTempWillingToRelocate(val)}
                                            />
                                        ))}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col>
                                        <Form.Label> Travel for Work<span style={{ color: 'red' }}> *</span></Form.Label><br />
                                        {['YES', 'NO'].map((val) => (
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label={val}
                                                name="travel"
                                                key={val}
                                                checked={tempWillingToTravelToWork === val}
                                                onChange={() => setTempWillingToTravelToWork(val)}
                                            />
                                        ))}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Form.Label> Weekly Working Days<span style={{ color: 'red' }}> *</span></Form.Label><br />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Six Days"
                                            checked={tempWillingToWorkSixDayWeeks === 'YES'}
                                            onChange={() => setTempWillingToWorkSixDayWeeks('YES')}
                                        />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Five Days"
                                            checked={tempWillingToWorkSixDayWeeks === 'NO'}
                                            onChange={() => setTempWillingToWorkSixDayWeeks('NO')}
                                        />
                                    </Col>
                                </Row>

                                {/* Expertise Form Field */}
                                <Form.Group className="mb-3">
                                    <div className="d-flex align-items-center mb-1 gap-1">
                                        <Form.Label className="mb-0">Expertise</Form.Label>
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your core skills, knowledge areas, and industry experience.(max 250 words).
                                            </div>
                                        </div>

                                    </div>
                                    <Form.Control
                                        style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                        as="textarea"
                                        rows={4}
                                        value={tempExpertiseText}
                                        onChange={handleExpertiseChange}
                                        isInvalid={!!fieldErrors.expertise}
                                        spellCheck="false"
                                    />
                                    <div className="text-end small text-muted">
                                        {countWords(tempExpertiseText)}/250 words
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.expertise}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* Achievements Form Field */}
                                <Form.Group className="mb-3">
                                    <div className="d-flex align-items-center mb-1 gap-1">
                                        <Form.Label className="mb-0">Achievements</Form.Label>
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your major accomplishments and career highlights (max 250 words).
                                            </div>
                                        </div>
                                    </div>
                                    <Form.Control
                                        style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                        as="textarea"
                                        rows={4}
                                        value={tempAchievementsText}
                                        onChange={handleAchievementsChange}
                                        isInvalid={!!fieldErrors.achievements}
                                        spellCheck="false"
                                    />
                                    <div className="text-end small text-muted">
                                        {countWords(tempAchievementsText)}/250 words
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.achievements}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className='candidate-profile-edit-cancel' onClick={closeModal}>Cancel</button>
                            <button
                                className="candidate-profile-edit-save"
                                onClick={saveChanges}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save'}
                            </button>
                        </Modal.Footer>
                    </Modal>



                    {/* Small-Screen Layout */}
                    <Row className="d-md-none align-items-center" >
                        <Col xs={3} className="d-flex justify-content-center" style={{ paddingLeft: '0', paddingRight: '0' }}>
                            <div className="rounded-circle overflow-hidden position-relative profile-pic-container "
                                onClick={() => inputFileRef.current?.click()}
                                style={{ cursor: 'pointer' }}
                            >
                                <Image
                                    src={candidate?.imageBlobUrl || default_profile_image}
                                    width={120}
                                    height={120}
                                    alt="Profile Image"
                                    aspectRatio="16x9"
                                />

                                {' '}
                                {uploading && (
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                        style={{ backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 10 }}
                                    >
                                        <Spinner animation="border" />
                                    </div>
                                )}
                                <div className="overlay" style={{ fontSize: '6px', display: 'flex', alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faPen} color="#F35824" style={{ fontSize: '6px' }} />
                                    <span className="ms-1">Edit Image</span>
                                </div>

                                <input
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.gif"
                                    ref={inputFileRef}
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />

                            </div>
                        </Col>
                        <Col xs={9} >
                            <h2 className="candidateTitle">
                                {_.get(candidateData, 'personalDetails.firstName')}{' '}
                                {_.get(candidateData, 'personalDetails.lastName')} | {candidateId}
                                <button onClick={openModal} className="candidate-profile-edit-button ms-3">
                                    <FontAwesomeIcon icon={faPen} />
                                </button>

                            </h2>
                            <h3 className="candidateSubTitle">
                                {_.get(candidateData, 'workExperience.currentRole.designation')}
                                <span className="candidateSubTitleStyle2">
                                    {_.get(candidateData, 'workExperience.currentRole.designation') ? ' at ' : ''}
                                    {_.get(candidateData, 'workExperience.currentRole.orgName')},
                                    {_.get(candidateData, 'workExperience.currentRole.location')}
                                </span>
                            </h3>
                        </Col>
                        <Col>
                            <br />
                            <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                <FontAwesomeIcon className="preference-icon" icon={faIndustry} /> {industry} - {industrySubcategory}
                                <br />
                                <FontAwesomeIcon className="preference-icon" icon={faBuilding} /> {jobFunction} - {functionSubcategory}
                            </h3>
                        </Col>
                        <Col md={6} xs={12} className="d-md-flex justify-content-left pt-3">
                            <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                <FontAwesomeIcon className="preference-icon" icon={faMapMarkerAlt} /> Location Preference: {' '}
                                {[
                                    _.get(candidateData, 'valueAdds.locationPref1') && `${_.get(candidateData, 'valueAdds.locationPref1')} `,
                                    _.get(candidateData, 'valueAdds.locationPref2') && `${_.get(candidateData, 'valueAdds.locationPref2')} `,
                                    _.get(candidateData, 'valueAdds.locationPref3') && `${_.get(candidateData, 'valueAdds.locationPref3')} `,
                                ]
                                    .filter(Boolean)
                                    .join(' | ')}
                            </h3>

                        </Col>
                        <Col md={12} xs={12} className="d-md-flex justify-content-left pt-2">
                            <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                {' '}
                                <FontAwesomeIcon className="preference-icon" icon={faBriefcase}></FontAwesomeIcon> Work Preference :{' '}
                                {(_.get(candidateData, 'valueAdds.jobTypes') || []).map((jobType, index, arr) => (
                                    <React.Fragment key={index}>
                                        {jobType}
                                        {index < arr.length - 1 ? ' | ' : ''}
                                    </React.Fragment>
                                ))}
                            </h3>
                        </Col>
                        <Col md={12} xs={12} className="d-md-flex justify-content-left pt-2">
                            <h3 className="candidateSubTitle candidateSubTitleStyle2">
                                <span className="col-sm-4 d-block d-md-inline mb-2 ">
                                    <FontAwesomeIcon className="preference-icon" icon={faCar}></FontAwesomeIcon> Willing To Relocate :{' '}
                                    {_.get(candidateData, 'valueAdds.willingToRelocate')}
                                </span>
                                <span className="ps-md-2 col-sm-4 d-block d-md-inline mb-2 ">
                                    <FontAwesomeIcon className="preference-icon" icon={faBagShopping}></FontAwesomeIcon> Willing To Travel For Work :{' '}
                                    {_.get(candidateData, 'valueAdds.willingToTravelToWork')}
                                </span>
                                <span className="ps-md-2 col-sm-4 d-block d-md-inline mb-2 text-wrap text-break ">
                                    <FontAwesomeIcon className="preference-icon" icon={faCalendarAlt}></FontAwesomeIcon> Preferred Number of Working Days :{' '}
                                    {_.get(candidateData, 'valueAdds.willingToWorkSixDayWeeks') === 'YES'
                                        ? 'Six Days'
                                        : 'Five Days'}
                                </span>
                            </h3>
                        </Col><hr />
                        <Col md={4}>
                            <div className='smallscreen-metcontents'>

                                <Row>
                                    <Col md={12} className="d-flex justify-content-center align-items-center" style={{ gap: '16px', flexWrap: 'nowrap' }}>

                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                            <a
                                                href="#"
                                                className="resetLinkStyle candidateCVDownload d-flex align-items-center"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const resumePath = _.get(candidateData, 'personalDetails.resume[0].path', null);
                                                    const resumeName = _.get(candidateData, 'personalDetails.resume[0].displayFileName', null);
                                                    if (!resumePath || !resumeName) {
                                                        setErrorMessage('Resume not available for the candidate');
                                                    } else {
                                                        downloadFile(resumePath, resumeName);
                                                    }
                                                }}
                                            >
                                                <span style={{ color: '#F35824', fontWeight: 600 }}>Download CV</span>
                                                <FontAwesomeIcon icon={faDownload} className="ms-1" style={{ color: '#F35824' }} />
                                            </a>

                                            {/* <FontAwesomeIcon
                                                icon={faPen}
                                                size="sm"
                                                style={{ color: '#F35824', cursor: 'pointer' }}
                                                onClick={() => inputResumeRef.current.click()}
                                                disabled={uploading}
                                            /> */}
                                            <input
                                                type="file"
                                                ref={inputResumeRef}
                                                style={{ display: 'none' }}
                                                onChange={handleResumeUpload}
                                                accept=".pdf,.doc,.docx"
                                            />
                                        </div>

                                        {/* <div style={{ color: '#ccc' }}>|</div>

                                        <a href="#" className="resetLinkStyle metVidStyle d-flex align-items-center">
                                            <span>Met Vid Video</span>
                                            <FontAwesomeIcon className="orangeColor ms-1" icon={faPlayCircle} />
                                        </a> */}

                                    </Col>

                                    <Col md={12} className="d-md-flex justify-content-center">
                                        <Col md={12} className="d-md-flex justify-content-end rework-approve-buttons">
                                            <Button className="approve-button" onClick={() => setShowConfirmModal(true)}>
                                                Submit
                                            </Button>{' '}

                                            <Button className="approve-button" onClick={psychometricDashboardClick}>
                                                Take DISC Test
                                            </Button>
                                        </Col>
                                    </Col>

                                </Row>
                                <br />
                            </div>
                        </Col>
                        <hr />

                    </Row>
                    <Row className='d-md-none'>
                        <Col md={12} className="ps-4">
                            <div id="collapsibleSection">
                                <div className={`collapsible-content ${isCollapsed ? 'collapsed' : ''}`}>

                                    {/* Expertise Section */}
                                    <div className="d-flex align-items-center">
                                        <h2 className="candidateDisplaySectionHeadingStyle1 mb-0">Expertise</h2> &nbsp;
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your core skills, knowledge areas, and industry experience.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="candidateDisplaySectionContentStyle1 pt-2">

                                        <>
                                            {(_.get(candidateData, 'workExperience.currentRole.topThreeResponsibilities') || '')
                                                .split('\n')
                                                .filter((line) => line.trim() !== '')
                                                .map((text, index) => (
                                                    <p key={index}>{text}</p>
                                                ))}
                                        </>
                                    </div>

                                    {/* Achievements Section */}
                                    <div className="d-flex align-items-center mt-4">
                                        <h2 className="candidateDisplaySectionHeadingStyle1 mb-0">Achievements</h2> &nbsp;
                                        <div className="custom-tooltip-wrapper">
                                            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ color: '#F35824' }} />
                                            <div className="custom-tooltip-box">
                                                Your major accomplishments and career highlights.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="candidateDisplaySectionContentStyle1 pt-2">

                                        <>
                                            {(_.get(candidateData, 'workExperience.currentRole.topThreeAchievements') || '')
                                                .split('\n')
                                                .filter((line) => line.trim() !== '')
                                                .map((text, index) => (
                                                    <p key={index}>{text}</p>
                                                ))}
                                        </>
                                    </div>
                                </div>
                            </div>
                        </Col>


                    </Row>
                    <Row className="d-md-none">
                        <Col className="d-flex justify-content-center candidateCVDownload">
                            <a id="toggleButton" onClick={toggleContent}>
                                {isCollapsed ? 'View More' : 'View Less'}{' '}
                                <span>
                                    <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
                                </span>
                            </a>
                        </Col>
                    </Row>

                    {/* small screen end */}
                </Card.Body>
            </Card>
            <Card className="mt-3 p-0 navCard remove-border-radius">
                <Card.Body className="candidateInformation p-0">
                    <CandidateProfileNav setChildNavigation={setChildCandidateNavigation} />
                </Card.Body>
            </Card>
            <Card className="mt-3 p-0 navCard">
                <Card.Body className="candidateInformation p-0">
                    <CandidateProfileContentPane
                        currentNavigation={childCandidateNavigation}
                        candidateData={candidateData}
                        fetchCandidateData={fetchCandidateData}
                        refreshPage={refreshPage}
                    />
                </Card.Body>
            </Card>
            <Card className="mt-3 p-0 navCard mb-3">
                <Card.Body className="candidateInformation p-0">
                    <DiscreteReferenceChecks
                        reference1={_.get(candidateData, 'valueAdds.reference1')}
                        reference2={_.get(candidateData, 'valueAdds.reference2')}
                    ></DiscreteReferenceChecks>
                </Card.Body>
            </Card>
            <CandidateProfessionalMembershipContent
                professionalReferences={professionalReferences}
                setProfessionalReferences={setProfessionalReferences}
                professionalMemberships={professionalMemberships}
                setProfessionalMemberships={setProfessionalMemberships}
            ></CandidateProfessionalMembershipContent>

        </Col>
    );
};